import {
  GqlModel,
  GqlModelOperator,
  GqlQueryModel,
} from "../graphql/graphql.model";
import gql from "graphql-tag";
import {jsonProperty} from "../json.model";

export class LocalizationCodeGqlModel extends GqlQueryModel {
  static mapper: GqlModelOperator<LocalizationCodeGqlModel> = GqlModel.buildMapper(LocalizationCodeGqlModel, "localizationCode");

  static query: any = gql`
    query getLocalizationCode($localizationCode: String) {
      localizationCode: localizationCode(localizationCode: $localizationCode) {
        __typename
        id
        localizationCode
        localizationDescription
        isDefault
      }
    }
  `;

  @jsonProperty("string") id: string;
  @jsonProperty("string") localizationCode: string;
  @jsonProperty("string") localizationDescription: string;
  @jsonProperty("boolean") isDefault: boolean;
  error: string = "";

  static variables(localizationCode: string) {
    return {localizationCode};
  }
}
